import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ArrowRightIcon } from 'lucide-react';
export function CTAButton({
  className = ''
}: {
  className?: string;
}) {
  const scrollToPricing = () => {
    const el = document.getElementById('final-cta');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <motion.button onClick={scrollToPricing} whileHover={{
    scale: 1.02,
    y: -2
  }} whileTap={{
    scale: 0.98
  }} animate={{
    boxShadow: ['0px 4px 20px rgba(201,169,110,0.3)', '0px 4px 40px rgba(201,169,110,0.6)', '0px 4px 20px rgba(201,169,110,0.3)']
  }} transition={{
    boxShadow: {
      repeat: Infinity,
      duration: 4,
      ease: 'easeInOut'
    },
    scale: {
      duration: 0.3
    },
    y: {
      duration: 0.3
    }
  }} className={`group relative bg-gold text-burgundy-dark font-bold py-5 px-6 md:px-10 rounded-full shadow-xl transition-all duration-500 text-center flex flex-col items-center justify-center w-full max-w-xl mx-auto overflow-hidden ${className}`} data-id="element-304">
      {/* Shimmer Effect */}
      <div className="absolute inset-0 -translate-x-full animate-[shimmer_3s_infinite] bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-12 z-10" data-id="element-305"></div>

      {/* Hover Glow Background */}
      <div className="absolute inset-0 rounded-full bg-white opacity-0 group-hover:opacity-20 transition-opacity duration-500 z-0" data-id="element-306"></div>

      <span className="relative z-20 text-base md:text-lg lg:text-xl mb-2 flex items-center gap-2" data-id="element-307">
        ¡QUIERO RECUPERAR MI CHISPA AHORA!
        <ArrowRightIcon className="w-5 h-5 opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300" data-id="element-308" />
      </span>

      <span className="relative z-20 text-xs md:text-sm font-medium opacity-80 flex items-center gap-1.5" data-id="element-309">
        <LockIcon className="w-3.5 h-3.5" data-id="element-310" /> Compra segura. Descarga
        instantánea.
      </span>
    </motion.button>;
}